export default "__VITE_ASSET__8a9TjHXF__"